import { createFileRoute } from '@tanstack/react-router';
import { WorkspacePicker } from '../components/onboarding/workspace-picker.js';

export const Route = createFileRoute('/workspaces/select')({
  component: WorkspaceSelectRoute,
});

function WorkspaceSelectRoute() {
  return <WorkspacePicker />;
}
